import { useState } from 'react';
import Modal from '../../components/common/Modal';
import SearchableSelect from '../../components/common/SearchableSelect';
import { HOSPITALAR_LABELS } from '../../utils/acreditacaoOpcoes';

const HOSPITALAR_OPCOES = Object.entries(HOSPITALAR_LABELS).map(([value, label]) => ({ value, label }));

export default function SubsecaoForm({ secao, subsecao, onClose, onSalvar }) {
  const [numero, setNumero] = useState(subsecao?.numero || '');
  const [nome, setNome] = useState(subsecao?.nome || '');
  const [hospitalar, setHospitalar] = useState(subsecao?.hospitalar || 'aplicavel');
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setEnviando(true);
    try {
      if (subsecao) {
        await onSalvar({ nome, hospitalar });
      } else {
        await onSalvar({ id_secao: secao.id_secao, numero, nome, hospitalar });
      }
      onClose();
    } catch (err) {
      setErro(err?.response?.data?.detail || 'Não foi possível salvar.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Modal titulo={subsecao ? 'Editar subseção' : `Nova subseção — Seção ${secao.numero}`} onClose={onClose}>
      <form className="am-form" onSubmit={handleSubmit}>
        {!subsecao && (
          <label className="am-field">
            <div className="am-field__label-row">
              <span className="am-field__label">Número</span>
            </div>
            <input value={numero} onChange={(e) => setNumero(e.target.value)} placeholder={`${secao.numero}.1`} required />
          </label>
        )}
        <label className="am-field">
          <div className="am-field__label-row">
            <span className="am-field__label">Nome</span>
          </div>
          <input value={nome} onChange={(e) => setNome(e.target.value)} required />
        </label>
        <div>
          <div className="am-field__label mb-1">Obrigatoriedade (Serviços Hospitalares)</div>
          <SearchableSelect options={HOSPITALAR_OPCOES} value={hospitalar} onChange={setHospitalar} required />
        </div>
        {erro && <div className="am-field__error">{erro}</div>}
        <div className="am-form__actions">
          <button type="button" className="am-btn am-btn-outline" onClick={onClose}>
            Cancelar
          </button>
          <button type="submit" className="am-btn am-btn-dark" disabled={enviando}>
            {enviando ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
